import { GetContactActivitiesQuery, useGetContactActivitiesQuery } from "generated/graphql";
import { useMemo } from "react";

export type ContactActivityRow = NonNullable<GetContactActivitiesQuery["getContactActivities"]>["data"][number];

type UseContactActivitiesArgs = {
  contactId?: string | null;
  first?: number;
  page?: number;
};

export const useContactActivities = ({
  contactId,
  first = 50,
  page = 1,
}: UseContactActivitiesArgs) => {
  const { data, loading, error } = useGetContactActivitiesQuery({
    variables: {
      contactId: contactId ?? "",
      first,
      page,
    },
    skip: !contactId,
    fetchPolicy: "cache-and-network",
  });

  const activities = useMemo(() => data?.getContactActivities?.data ?? [], [data]);

  return { activities, loading, error } as const;
};
